import {
    useState,
    useMemo,
} from 'react'

import {
    gridFilterModelSelector,
    GridEventListener,
    useGridApiContext,
    useGridEvent,
} from '@mui/x-data-grid-pro'
import {
    getActiveFilters,
} from 'app/PoC/DataGridDemoPages/components/SkyBaseDataGrid/utils/FilterModel.utils'

const useActiveFiltersCount = (showFilterButton: boolean): number => {
    const [
        activeFiltersCount,
        setActiveFiltersCount,
    ] = useState<number | null>(null)
    const apiRef = useGridApiContext()

    const initialActiveFiltersCount = useMemo(() => {
        const filterModel = gridFilterModelSelector(apiRef)

        return getActiveFilters(filterModel).length
    }, [apiRef])
    const handleFilterModelChangeEvent: GridEventListener<'filterModelChange'> = (params) => {
        setActiveFiltersCount(getActiveFilters(params).length)
    }

    useGridEvent(apiRef, 'filterModelChange', handleFilterModelChangeEvent)

    return useMemo(() => {
        if (showFilterButton) {
            return activeFiltersCount === null ? initialActiveFiltersCount : activeFiltersCount
        }
        return 0
    }, [
        activeFiltersCount,
        initialActiveFiltersCount,
        showFilterButton,
    ])
}

export default useActiveFiltersCount
